import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { TranslocoPipe } from '@jsverse/transloco';
import { finalize } from 'rxjs';
import { AuthService, LanguageCode, LanguageService, ProfileService } from '@core';

@Component({
  selector: 'app-language-selector',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatMenuModule, TranslocoPipe],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss',
})
export class LanguageSelectorComponent {
  private readonly languageService = inject(LanguageService);
  private readonly authService = inject(AuthService);
  private readonly profileService = inject(ProfileService);

  readonly saving = signal(false);
  readonly currentLanguage = this.languageService.currentLanguage;

  selectLanguage(languageCode: LanguageCode): void {
    if (this.saving() || languageCode === this.currentLanguage()) {
      return;
    }

    const previous = this.currentLanguage();
    this.languageService.setLanguage(languageCode);

    if (!this.authService.isAuthenticated()) {
      return;
    }

    this.saving.set(true);
    this.profileService
      .updateLanguage(languageCode)
      .pipe(finalize(() => this.saving.set(false)))
      .subscribe({
        error: () => {
          this.languageService.setLanguage(previous);
        },
      });
  }
}
